import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import BalanceToolbar from '../../components/BalanceToolbar';
import { CapitalBalanceList } from './CapitalBalanceList';
import CapitalBalanceKpiCards from './CapitalBalanceKpiCards';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CapitalBalanceListView = ({ config }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t(config.titleKey)}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <BalanceToolbar config={config} />
          <Box mt={3}>
            <CapitalBalanceKpiCards config={config} />
          </Box>
          <Box mt={3}>
            <CapitalBalanceList config={config} />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

CapitalBalanceListView.propTypes = {
  config: PropTypes.object.isRequired
};

export default CapitalBalanceListView;
